import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MsalConfigService {
  getMsalConfig() {
    const el = document.getElementById('msal-config');
    return {
      clientId: el?.getAttribute('data-clientid') ?? '',
      authority: el?.getAttribute('data-authority') ?? '',
      redirectUri: el?.getAttribute('data-redirecturi') ?? '',
      scope: el?.getAttribute('data-scope') ?? ''
    };
  }
}
